import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { Base64 } from 'js-base64';

import { AdfoxCardListingItem } from '../ListingItem';

export function MainPageBanner({ bundleParams }: TAdFoxBannerTemplate) {
  const deviceType = useDeviceType();

  if (!bundleParams?.htmlBase64) {
    return null;
  }

  const isPhone = () => deviceType === 'phone';
  const decodedParams = Base64.decode(bundleParams.htmlBase64);
  const parsedDecodedParams = JSON.parse(decodedParams);
  const { image, title, description, phone, footnote, url } = parsedDecodedParams;

  return (
    <AdfoxCardListingItem
      image={image}
      title={title}
      description={description}
      siteName={phone}
      footnote={footnote}
      url={url}
      height={isPhone() ? 316 : 400}
    />
  );
}
